import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { Icon, Table } from "semantic-ui-react";
import LoadingAction from "@common/redux/actions/LoadingAction";
import { getBackgroundColour, getTextColour } from "@helpers/colours";
import Option from "@common/components/shared/Option";

class DataGrid extends React.Component {
  state = {
    activeRow: null,
    sortBy: null,
    data: this.props.data,
    direction: "ascending",
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.data !== this.props.data) {
      this.setState({
        activeRow: null,
        sortBy: null,
        direction: "ascending",
        data: this.props.data,
      });
    }
  };

  onRowClick = (row) => {
    if (!this.props.disableActiveRow) {
      this.setState({ activeRow: row }, () => {
        if (typeof this.props.onRowClick === "function") {
          this.props.onRowClick(row);
        }
      });
    }
  };

  onCellClick = (cell) => {
    if (
      typeof this.props.onCellClick === "function" &&
      this.props.disableActiveRow
    ) {
      this.props.onCellClick(cell);
    }
  };

  renderData() {
    return this.state.data.map((data, index) => {
      const activeRow = this.props.activeRow
        ? this.props.activeRow
        : this.state.activeRow;
      return (
        <Table.Row
          className={!this.props.disableActiveRow && "clickable"}
          active={data === activeRow}
          key={`row_${index}`}
          onClick={() => {
            this.onRowClick(data);
          }}
        >
          {this.dataToRow(data, index)}
        </Table.Row>
      );
    });
  }

  handleSort = (sortBy) => {
    let isString = false;

    this.state.data.forEach((o) => {
      if (!isString && isNaN(o.cellData[sortBy].data.actualValue)) {
        isString = true;
      }
    });

    const sorted = _.orderBy(
      this.state.data,
      function (o) {
        return !isString
          ? Number(o.cellData[sortBy].data.actualValue)
          : o.cellData[sortBy].data.actualValue;
      },
      this.state.direction === "ascending" ? "desc" : "asc",
    );

    this.setState({
      direction:
        this.state.direction === "ascending" ? "descending" : "ascending",
      sortBy,
      data: sorted,
    });
  };

  getCellAlignment = (index) => {
    const textAlign = ["left", "center", "right"];

    if (!Array.isArray(this.props.rowDef)) {
      return;
    }

    if (!this.props.rowDef[index]) {
      return textAlign[0];
    } else {
      const alignment = textAlign[this.props.rowDef[index].alignment];
      return alignment || textAlign[0];
    }
  };

  getHeaderAlignment = (index) => {
    const textAlign = ["left", "center", "right"];
    return textAlign[index];
  };

  dataToRow(data, rowIndex) {
    return data.cellData
      .filter((item) => !item.hide)
      .map((item, index) => {
        const displayValue =
          item.data.displayValue !== "" ? item.data.displayValue : " ";
        return (
          <Table.Cell
            textAlign={this.getCellAlignment(index)}
            key={`cell_${rowIndex}_${index}`}
            singleLine={true}
            className={item.data.flash ? "flash" : ""}
            style={{
              background: getBackgroundColour(item.data),
              color: getTextColour(item.data),
            }}
            onClick={
              item.type === "cell" ? () => this.onCellClick(item.data) : null
            }
          >
            {item.type === "cell" ? (
              displayValue
            ) : (
              <Option
                option={item.data}
                onChange={(event, option) =>
                  this.props.onOptionChange(event, rowIndex, option)
                }
              />
            )}
          </Table.Cell>
        );
      });
  }

  renderHeadings() {
    if (!Array.isArray(this.props.headings)) {
      return;
    }

    return this.props.headings.map((data, index) => {
      return (
        <Table.HeaderCell
          collapsing={data.collapsing || false}
          key={`header_${index}`}
          textAlign={this.getHeaderAlignment(data.alignment)}
          sorted={index === this.state.sortBy ? this.state.direction : null}
          onClick={() => !this.props.disableSort && this.handleSort(index)}
        >
          {data.text}
        </Table.HeaderCell>
      );
    });
  }

  render() {
    let classes = "stretch ";

    if (!this.props.noScroll) {
      classes += " table-overflow ";
    }

    classes += this.props.className;

    if (!this.state.data || !this.state.data.length) {
      return (
        <div
          style={{
            ...this.props.style,
            backgroundColor: "#FFF",
            borderRadius: "0.286em",
          }}
          className={classes}
        >
          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <Icon name="dont" size="large" disabled />{" "}
            {this.props.noResults
              ? this.props.noResults
              : "There are no results for the current set of filters."}
          </div>
        </div>
      );
    }

    return (
      <div
        style={{
          ...this.props.style,
          backgroundColor: "#FFF",
          borderRadius: "0.286em",
        }}
        className={classes}
      >
        <Table
          unstackable
          sortable={!this.props.disableSort}
          size="small"
          compact="very"
          {...(!this.props.noScroll ? { basic: "very" } : { basic: true })}
          celled
          className="border-bottom"
        >
          <Table.Header className="sticky">
            <Table.Row className="bg-white">{this.renderHeadings()}</Table.Row>
          </Table.Header>
          <Table.Body>{this.renderData()}</Table.Body>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: LoadingAction.getStatePath(state),
  };
};

export default connect(mapStateToProps)(DataGrid);
